import { Routes, RouterModule } from '@angular/router';
import {ContactUsComponent} from './Contact-us.component';
import { NgModule } from '@angular/core';

export const routes: Routes = [
  {   path: '', component: ContactUsComponent },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes)
  ]
})

export class ContactUsModuleRouting { }
